/**
 * 存储单选、多选、下拉选项列表数据
 * */
// 引入localStorage相关方法
import {getStorage, setStorage, cleanStorage} from "@/utils/myUtils"

const optionsModule = {
  state: {
    options: {}
  },
  getters: {},
  mutations: {
    //设置选项数据
    SET_OPTIONS: (state, data) => {
      let {name = "null", value = []} = data;
      state.options[name] = value;
    }
  },
  actions: {
    //设置选项数据
    set_options: (context, data) => {
      context.commit("SET_OPTIONS", data);
    }
  }
}

export default optionsModule;




// WEBPACK FOOTER //
// ./src/store/modules/optionsModule.js